<template>
  <div>
    <!-- <span v-if="model.has_transport">
      Pentru cautarea dumneavoastra nu mai exista locuri disponibile la avion.
      Va rugam sa schimbati criteriile de cautare.
    </span> -->
    <span v-if="model.results.length" class="d-flex justify-content-between">
      <span>
        <b-avatar variant="primary" icon="folder-fill" size="1.3rem" class="mr-2"></b-avatar><strong>Rezultate: {{ model.results.length }}</strong>
      </span>
      <span>
        <b-avatar variant="success" icon="geo-alt" size="1.3rem" class="mr-2"></b-avatar><strong class="text-success">Destinatie: {{ model.params.resortName}}</strong>
      </span>
      <span>
        <b-avatar variant="danger" icon="moon" size="1.3rem" class="mr-2"></b-avatar><strong class="text-danger">Numar nopti: {{ duration }}</strong>
      </span>
    </span>
    <span v-else>
      Pentru cautarea dumneavoastra sistemul nu a generat niciun rezultat. Va rugam sa schimbati criteriile de cautare sau sa ne transmiteti un email la adresa <a href="mailto:confirmarib2b@helloholidays.ro">confirmarib2b@helloholidays.ro</a>
    </span>
  </div>
</template>

<script>
import moment from 'moment'
import model from '../services/model'
export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>

<style>
.results {
  background-color: rgb(112, 99, 90);
  padding: 10px;
  color: #fff;
  border-radius: 4px;
}
.breadcrumb li {
  font-size: 13px;
  text-align: center;
}
.SPOEBD {
  font-size: 14px;
  font-weight: 600;
  color: #d13239;
}

.RQNA {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.FCAVL {
  font-size: 14px;
  font-weight: 600;
  color: green;
}
</style>
